import { gql } from '@apollo/client';

export const SEARCH_ITEM_CREATED = gql`
    query LocationsQuery(
        $__typename: String!
        $index: String!
        $query: String!
        $filters: String!
        $hit: Number!
        $page: Number!
        $facets: [String]!
    ) {
        items
            @algolia(
                __typename: "algolia_items_created"
                index: $index
                filters: $filters
                hitsPerPage: $hit
                query: $query
                page: $page
                facets: $facets
            ) {
            hits
            nbHits
            facets
            page
            nbPages
        }
    }
`;
